// extracted by mini-css-extract-plugin
module.exports = {"badgeWrap":"Badge_badgeWrap__lT5AL"};